import { H1 } from '../../components/elements/Text';
import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import { useParams } from 'react-router-dom';
import { useGetCompany } from '../../hooks/use-hydra/admin';
import day from 'dayjs';
import utc from 'dayjs/plugin/utc';

import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import { useGetCompanyProjectSubmissions } from '../../hooks/use-hydra/admin';
import CompanyProjectSubmission from '../../components/Admin/CompanyProjectSubmission';
import { ROUTES } from '../../routing';
day.extend(utc);

const NavbarWithBreadcrumbs = ({
  name,
  companyId,
}: {
  name?: string;
  companyId: string;
}) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: ROUTES.HOME.getPath(),
      },
      {
        label: 'Teams',
        url: ROUTES.ADMIN.COMPANIES.getPath(),
      },
      {
        label: name || 'Company',
        url: ROUTES.ADMIN.COMPANY.getPath({ companyId }),
      },
      {
        label: 'Company Projects',
        url: ROUTES.ADMIN.COMPANY_PROJECTS.getPath({ companyId }),
      },
      {
        label: 'Submission',
        url: null,
      },
    ]}
  />
);

export default function CompanyProjectSubmissionPage() {
  const { id: companyId, submissionId } =
    useParams<{ id: string; submissionId: string }>();
  const {
    data: companyData,
    isLoading,
    error,
    refetch,
  } = useGetCompany(parseInt(companyId));
  const {
    data: submissionData,
    isLoading: isSubmissionLoading,
    error: submissionError,
    refetch: refetchSubmission,
  } = useGetCompanyProjectSubmissions(parseInt(companyId));

  const submission =
    (submissionData?.submissions ?? []).find(
      (s) => s.submissionId === parseInt(submissionId)
    ) ?? null;

  return (
    <PageWithAsyncData
      isLoading={isLoading || isSubmissionLoading}
      error={error || submissionError}
      retry={() => {
        refetch();
        refetchSubmission();
      }}
      noScroll
    >
      <NavbarWithBreadcrumbs name={companyData?.name} companyId={companyId} />
      <CompanyPageWrapper currentPage={COMPANY_PAGES.COMPANY_PROJECTS}>
        <H1>{submission?.learner?.name}'s Project Submission</H1>

        {submission && (
          <CompanyProjectSubmission
            submissionId={parseInt(submissionId)}
            submission={submission}
            companyId={parseInt(companyId)}
            refetchSubmissions={refetchSubmission}
          />
        )}
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
